/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const CommonBannedAsinResponseDTOMarketplaceEnum = {
    UnitedStates: 'UNITED_STATES',
    Brazil: 'BRAZIL',
    Canada: 'CANADA',
    Mexico: 'MEXICO',
    Australia: 'AUSTRALIA',
    Japan: 'JAPAN',
    India: 'INDIA',
    Singapore: 'SINGAPORE',
    Germany: 'GERMANY',
    Spain: 'SPAIN',
    France: 'FRANCE',
    Italy: 'ITALY',
    Netherlands: 'NETHERLANDS',
    Belgium: 'BELGIUM',
    Poland: 'POLAND',
    Sweden: 'SWEDEN',
    UnitedKingdom: 'UNITED_KINGDOM',
    Ireland: 'IRELAND',
    UnitedArabEmirates: 'UNITED_ARAB_EMIRATES',
    Egypt: 'EGYPT',
    SaudiArabia: 'SAUDI_ARABIA',
    All: 'ALL'
};
/**
 * Check if a given object implements the CommonBannedAsinResponseDTO interface.
 */
export function instanceOfCommonBannedAsinResponseDTO(value) {
    return true;
}
export function CommonBannedAsinResponseDTOFromJSON(json) {
    return CommonBannedAsinResponseDTOFromJSONTyped(json, false);
}
export function CommonBannedAsinResponseDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'value': json['value'] == null ? undefined : json['value'],
        'brand': json['brand'] == null ? undefined : json['brand'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
        'marketplace': json['marketplace'] == null ? undefined : json['marketplace'],
        'issueCodes': json['issueCodes'] == null ? undefined : json['issueCodes'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'reportedBy': json['reportedBy'] == null ? undefined : json['reportedBy'],
    };
}
export function CommonBannedAsinResponseDTOToJSON(json) {
    return CommonBannedAsinResponseDTOToJSONTyped(json, false);
}
export function CommonBannedAsinResponseDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'value': value['value'],
        'brand': value['brand'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
        'marketplace': value['marketplace'],
        'issueCodes': value['issueCodes'],
        'reason': value['reason'],
        'reportedBy': value['reportedBy'],
    };
}
